export default "/images/vendor/flag-icon-css/flags/4x3/tj.svg?4c009c916e4eafb0debdff42d2b7e07e";